interface TiltLostBannerProps {
  /** true quando algum tiltímetro está sem sinal (fonte: `useTiltSignalLost`, stub por ora). */
  visible: boolean;
}

/**
 * Banner pulsante de "tiltímetro sem sinal" (GUPM-158). Tiltímetro sem
 * comunicação é gatilho de emergência no v5.10 — merece destaque persistente
 * no topo. Puro: só renderiza quando `visible`. `role="alert"` para leitores.
 */
export function TiltLostBanner({ visible }: TiltLostBannerProps) {
  if (!visible) return null;

  return (
    <div
      role="alert"
      className="flex items-center gap-2 px-4 py-2 text-sm font-bold text-white bg-level-emergencia/90 border-b border-level-emergencia animate-pulse shrink-0"
    >
      <span aria-hidden>📡</span>
      <span>Tiltímetro sem sinal — verificar comunicação em campo imediatamente.</span>
    </div>
  );
}
